import {Button} from "@mui/material";
import React from "react";
import {useNavigate} from "react-router-dom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

const BackButton = () => {
  const navigate = useNavigate();

  return (
    <Button
      onClick={() => navigate('/')}
      aria-label="Back"
      sx={{
        minWidth: 'auto',
        padding: 1,
        color: '#0063a6',
        borderRadius: 0,
        '&:hover': {
          backgroundColor: 'rgba(0, 99, 166, 0.08)',
        },
      }}
    >
      <ArrowBackIcon sx={{ fontSize: '1.6rem' }} />
    </Button>
  )
}

export default BackButton;
